module.exports = __webpack_public_path__ + "img/three1Orange.07152fc4.jpg";